// Bootstrap for the legacy `page_args` global used by `qb.*.js` page
// scripts. Reads the `<meta name="page-data">` tag (emitted via the
// `page_data_tag` Rails helper) and assigns the parsed JSON to
// `window.page_args` so that legacy modules can keep referencing
// `page_args.foo` as a bare global.
//
// Runs on both the initial cold load and every `turbo:load`, so
// navigating between pages refreshes `page_args` to match the new view.
// On pages without a `page-data` tag, `page_args` is reset to `{}` so
// state from the previous page never leaks across visits.
//
// Per-page modules that need additional named globals should keep their
// own local loader; this file only manages the shared `page_args` contract.

function loadPageArgs() {
  const meta = document.querySelector('meta[name="page-data"]');
  if (!meta) {
    window.page_args = {};
    return;
  }
  try {
    window.page_args = JSON.parse(meta.content);
  } catch (e) {
    window.page_args = {};
    console.error("[lib/page_args] invalid page-data JSON", e);
  }
}

document.addEventListener("turbo:load", loadPageArgs);
loadPageArgs();
